import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMapPinComponent } from "./med-icon-map-pin.component";

@NgModule({
  declarations: [
    MedIconMapPinComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMapPinComponent,
  ],
})
export class MedIconMapPinModule { }
